// x-event-type-include.js

/*
On event list pages, event types are currently only available as data-attributes.
Example of list-element:
<div class="vrtx-resource vevent" data-event-type="Forestilling, Konsert, Utstilling">

This scrips grabs the event-type attributes and adds them as separate spans in a div,
which is appended to the list-item content.

If you want to place the element differently, use css grid or flex order.
*/


export default function xEventTypeInclude() {

  // Event list. Add data-event-types to markup.
  const eventList = document.querySelector("#vrtx-event-listing");

  if (eventList) {
    const eventListItemsAll = eventList.querySelectorAll(".vrtx-resource");

    eventListItemsAll.forEach(eventListItem => {
      const dataEventType = eventListItem.getAttribute("data-event-type");
      const itemContent = eventListItem.querySelector(".vrtx-list-item-content");

      if (dataEventType) {
        // Split the event-type comma-separated list into an array
        const eventTypeArray = dataEventType.split(',');

        // Create a container for the event-type
        const eventTypeContainer = document.createElement("div");
        eventTypeContainer.className = "event-type";

        // Create a span for each element in the array and add them to the container.
        eventTypeArray.forEach(item => {
          const eventTypeSpan = document.createElement("span");
          eventTypeSpan.textContent = item.trim();
          eventTypeContainer.appendChild(eventTypeSpan);
        });

        // Add the event-type container to itemContent
        itemContent.appendChild(eventTypeContainer);
      }
    });
  }
}